import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconCheckProps extends SVGProps<any> {}
export class SVGIconCheck extends Component<SVGIconCheckProps> {
  render() {
    const { width = 24, height = 24, color = '#039158', ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-check"
        width={`${width}`}
        height={`${height}`}
        viewBox="-87 89 24 24"
        {...rest}
      >
        <path
          d="M-84.7 101.8c-.9.9-.9 2.3 0 3.2l4 4c.9.9 2.3.9 3.2 0l12.8-12.8c.9-.9.9-2.3 0-3.2-.9-.9-2.3-.9-3.2 0l-11.2 11.2-2.3-2.3c-.9-1-2.4-1-3.3-.1z"
          fill={color}
        />
      </SVG>
    );
  }
}
